/**
 * bootprompt.js locale configuration
 * locale : Swedish
 * author : Mattias Reichel
 */

import { addLocale } from "../bootprompt";

addLocale("sv", {
  OK: "OK",
  CANCEL: "Avbryt",
  CONFIRM: "OK",
});
